export const leat = {
  seo: {
    title: 'LEAT loyaliteitsintegratie | Bistroo',
    description: 'Start een loyaliteitsprogramma voor je restaurant via LEAT en Bistroo. Klanten sparen automatisch punten bij elke online bestelling.',
  },
  hero: {
    category: 'Loyaliteitsprogramma',
    description: 'Laat klanten automatisch spaarpunten verdienen bij elke Bistroo-bestelling. Meer herhaalaankopen, een loyale klantenkring en hogere omzet.',
  },
  about: {
    title: 'Wat doet LEAT?',
    p1: 'LEAT (Loyalty, Engagement, Acquisition & Technology) is een slim loyaliteits- en marketingplatform speciaal voor de horeca. Met LEAT bouw je een eigen spaarprogramma waarmee klanten punten verdienen, beloningen ontvangen en terugkomen voor meer.',
    p2: 'Via de Bistroo × LEAT-koppeling worden spaarpunten automatisch bijgeschreven bij elke online bestelling. Klanten zien hun puntenbalans in de app en kunnen beloningen direct inzetten bij de volgende bestelling. Jij beheert het programma volledig vanuit het LEAT-dashboard.',
    stats: [
      { value: '+30%', label: 'hogere bestelfrequentie' },
      { value: '2×', label: 'hogere klantwaarde' },
      { value: '85%', label: 'klantbehoud' },
    ],
    benefits_title: 'Wat levert de koppeling op?',
    benefits: [
      'Automatisch spaarpunten bij elke online bestelling',
      'Klanten inzetten punten als betaalmiddel',
      'Gerichte marketingcampagnes via LEAT-platform',
      'Inzicht in klantgedrag en aankooppatronen',
      'Spaarpunten ook in de zaak zelf inwisselbaar',
    ],
  },
  wordcloud_title: 'LEAT in een oogopslag',
  wordcloud: ['Loyaliteitsprogramma', 'Spaarpunten', 'Klantretentie', 'Beloningen', 'Marketingplatform', 'Klantdata', 'Campagnes', 'Klantbinding', 'Herhaalaankopen', 'Punten inwisselen', 'AVG-compliant', 'Restaurantmarketing', 'Engagement', 'Retention', 'Segmentatie'],
  usp: {
    heading: 'Waarom Bistroo koppelen aan LEAT?',
    items: [
      { icon: 'bi-star-fill', title: 'Automatisch punten sparen', text: 'Elke bestelling via Bistroo boekt direct spaarpunten op het LEAT-account van de klant. Geen handmatige acties, geen gedoe.' },
      { icon: 'bi-arrow-repeat', title: 'Meer herhaalaankopen', text: 'Klanten met spaarpunten bestellen gemiddeld 2× vaker. LEAT geeft ze een reden om terug te komen, Bistroo maakt bestellen makkelijk.' },
      { icon: 'bi-megaphone-fill', title: 'Gerichte campagnes', text: 'Stuur via LEAT gepersonaliseerde aanbiedingen aan klanten op basis van hun bestelgeschiedenis uit Bistroo. Precies op het juiste moment.' },
      { icon: 'bi-graph-up-arrow', title: 'Inzicht in loyaliteit', text: 'Zie in één dashboard hoeveel punten uitstaan, wie je trouwste klanten zijn en welke beloningen het meest worden verzilverd.' },
      { icon: 'bi-share-fill', title: 'Klanten als ambassadeurs', text: 'LEAT ondersteunt referral-beloningen. Tevreden klanten die vrienden doorverwijzen verdienen extra punten, jij ontvangt nieuwe gasten zonder advertentiekosten.' },
      { icon: 'bi-gift-fill', title: 'Beloningen die motiveren', text: 'Stel beloningen in die bij jouw restaurant passen: van een gratis drankje tot korting op de volgende bestelling. Gasten streven naar het doel en bestellen vaker.' },
    ],
  },
  setup: {
    heading: 'Zo start je jouw loyaliteitsprogramma met LEAT',
    steps: [
      'Maak een LEAT-account aan en richt je loyaliteitsprogramma in (naam, merkkleur, spaarregel).',
      'Open het LEAT-beheerpaneel en kopieer je API-sleutel.',
      'Ga in Bistroo Merchant Portal naar Integraties → LEAT.',
      'Voer de LEAT API-sleutel in en koppel je klantendatabase.',
      'Stel je spaarregel in (bijv. 1 punt per €1 besteed) en activeer het programma.',
    ],
  },
  faq: {
    items: [
      { q: 'Hoe sparen klanten automatisch punten?', a: 'Zodra een klant een bestelling plaatst via jouw Bistroo-webshop en betaalt, worden spaarpunten automatisch bijgeschreven op hun LEAT-account. De klant ontvangt een melding via de LEAT-app of e-mail.' },
      { q: 'Kunnen klanten punten ook in de zaak zelf inwisselen?', a: 'Ja. Via de LEAT-kassaapp kunnen klanten hun punten inzetten bij een aankoop aan de toonbank. Punten zijn dus bruikbaar zowel online (via Bistroo) als offline.' },
      { q: 'Hoe stel ik beloningen in?', a: 'In het LEAT-dashboard definieer je zelf de beloningen: een gratis drankje, korting op de volgende bestelling, of een speciale treat. Je bepaalt hoeveel punten nodig zijn voor elke beloning.' },
      { q: 'Zijn klantgegevens beschermd volgens de AVG?', a: 'Ja. LEAT is volledig AVG-compliant en slaat klantgegevens op binnen de Europese Unie. Klanten geven expliciet toestemming voor deelname aan het spaarprogramma.' },
      { q: 'Kan ik marketingcampagnes sturen vanuit LEAT?', a: 'Ja. LEAT biedt geïntegreerde e-mail- en pushnotificatiecampagnes. Je kunt klanten targeten op basis van hun bestelgeschiedenis, spaarsaldo en aankooppatronen.' },
    ],
  },
}
